<template>
  <form method="post" action="/customer/account/login">
    <div class="field__group">
      <ValidationProvider class="checkout__field email" name="login[username]" v-slot="{ errors, classes }" rules="required|email" :skip-if-empty="false" tag="div" :name="$t('Email address')">
        <label>{{ $t('Email address') }} *</label>
        <input type="email" :placeholder="$t('Email address')" v-model="customer.email" :class="classes" name="login[username]" @change="checkCustomerEmail"/>
        <span class="field-error" v-if="errors.length">{{ $t(errors[0]) }}</span>
      </ValidationProvider>
      <i18n tag="div" path="You have an account. Would you like to {action}?" class="checkout__login__link" v-show="showLoginLink && !showLoginForm">
        <template #action>
          <span @click="showLoginForm = !showLoginForm">{{ $t('login') }}</span>
        </template>
      </i18n>
    </div>
    <div class="checkout__login-container field__group" v-show="showLoginForm">
      <input type="hidden" name="_token" :value="csrfToken"/>
      <input type="hidden" name="_source" value="checkout"/>
      <input type="hidden" name="referer" value="/checkout"/>
      <ValidationProvider class="checkout__field password" v-slot="{ errors, classes }" :skip-if-empty="false" tag="div" :name="$t('Password')">
        <label>{{ $t('Password') }} *</label>
        <input type="password" name="login[password]" :placeholder="$t('Password')" :class="classes"/>
        <span class="field-error" v-if="errors.length">{{ $t(errors[0]) }}</span>
      </ValidationProvider>
      <div class="actions">
        <input name="context" type="hidden" value="checkout">
        <button type="submit" class="_button _small">{{ $t('Log in') }}</button>
        <a class="_remind" href="/customer/account/forget">{{ $t('Forgot password?') }}</a>
      </div>
    </div>
  </form>
</template>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import {extend, ValidationProvider} from 'vee-validate';
  import {required, email} from 'vee-validate/dist/rules';

  extend('required', required);
  extend('email', email);

  @Component({
    name: 'checkout-address-login',
    components: {
      ValidationProvider
    }
  })

  export default class extends Vue {
    private customer: object = {email: null};
    private showLoginLink: boolean = false;
    private showLoginForm: boolean = false;

    private get csrfToken(): string {
      return document.head.querySelector('meta[name="csrf-token"]')?.['content'] || '';
    }

    private get getCustomerEmail(): string {
      return this.$store.getters['CheckoutGlobal/customerEmail'];
    }

    private async checkCustomerEmail() {
      if (!(this.customer || {}).hasOwnProperty('email') || !this.customer['email']) {
        return;
      }

      const {data} = await this.$store.dispatch('CheckoutGlobal/checkCustomerEmail', this.customer['email']);
      await this.$store.commit('CheckoutGlobal/SET_CUSTOMER_EMAIL', this.customer['email']);

      if (!data) {
        this.showLoginLink = true;
        return;
      }

      this.showLoginLink = false;
    };

    private created(): void {
      if (this.getCustomerEmail) {
        this.customer = {email: this.getCustomerEmail};
        this.checkCustomerEmail();
      }
    }
  }
</script>
